import { render } from "./LbrxWelcomeInterface.vue?vue&type=template&id=264a956e&scoped=true"
import script from "./LbrxWelcomeInterface.vue?vue&type=script&lang=js"
export * from "./LbrxWelcomeInterface.vue?vue&type=script&lang=js"

import "./LbrxWelcomeInterface.vue?vue&type=style&index=0&id=264a956e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264a956e"]])

export default __exports__